import { tsValidateDynamicObject, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocEHRParam_EHRTypes, smartDocParamType_EHR } from './types.js';
export const Validator_SmartDocEHRParam = {
    key: tsValidateString(),
    type: tsValidateValue([smartDocParamType_EHR]),
    resolver: tsValidateDynamicObject(tsValidateString(undefined, false), tsValidateValue([...smartDocEHRParam_EHRTypes]))
};
//# sourceMappingURL=validation.js.map